"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarPrefsStyles = exports.transactionLabelStyles = exports.daysGridStyles = exports.dayStyles = exports.weekDaysHeaderStyles = exports.headerStyles = void 0;
const daysPerRow = 7;
const headerStyles = (theme) => ({
    monthHeader: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 10,
        borderBottom: '1px solid #e0e0e0',
    },
    controlGroup: {
        display: 'flex',
    },
    controlRoot: {},
    iconControl: {
        width: 30,
        height: '100%',
        color: theme.palette.text.secondary,
    },
    iconControlDisabled: {
        color: `${theme.palette.text.disabled} !important`,
    },
    iconToday: {
        transform: 'rotate(45deg)',
        fontSize: '1rem',
        color: theme.palette.text.secondary,
    },
    settingsRoot: {
        position: 'absolute',
        top: '50%',
        right: 20,
        transform: 'translateY(-50%)',
    },
    settingsIconRoot: {
        padding: 12,
        borderRadius: '50%',
    },
    settingsIcon: {
        width: 20,
        height: 20,
        color: theme.palette.action.active,
    },
    cardHeaderNotClickable: {
        extend: 'cardHeader',
        cursor: 'default',
        padding: 0,
        paddingLeft: 10,
    },
    actions: {
        alignSelf: 'center',
        marginTop: 0,
    },
    title: {
        textTransform: 'uppercase',
    },
});
exports.headerStyles = headerStyles;
const weekDaysHeaderStyles = ({ spacing, palette, typography }) => ({
    weekDays: Object.assign(Object.assign({}, typography.subtitle2), { display: 'flex', background: palette.grey[200], border: `solid 1px ${palette.divider}`, borderLeft: 'none' }),
    dayLabel: {
        flex: `1 0 ${100 / daysPerRow}%`,
        maxWidth: `calc(100% / ${daysPerRow})`,
        textIndent: spacing(1),
        borderLeft: `solid 1px ${palette.divider}`,
        padding: '5px 0',
    },
});
exports.weekDaysHeaderStyles = weekDaysHeaderStyles;
const dayStyles = ({ palette, typography, components: { transactionCalendar, calendar } }) => ({
    day: {
        position: 'relative',
        flex: `1 0 ${100 / daysPerRow}%`,
        maxWidth: `calc(100% / ${daysPerRow})`,
        borderLeft: `solid 1px ${palette.divider}`,
        borderBottom: `solid 1px ${palette.divider}`,
        cursor: 'pointer',
        '&.small': {
            height: 30,
            minHeight: 30,
        },
        '&.big': {
            height: 35,
            minHeight: 35,
        },
    },
    notCurrentMonth: {
        background: transactionCalendar.notCurrentMonth,
    },
    header: {},
    dayIndicator: Object.assign(Object.assign({}, typography.subtitle2), { lineHeight: '16px', padding: 0 }),
    currentDay: {
        background: calendar.currentDayBackground,
        border: `solid 1px ${calendar.currentDayBorder}`,
    },
    txnWrapper: {
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
exports.dayStyles = dayStyles;
const daysGridStyles = ({ palette }) => ({
    days: {
        background: palette.common.white,
        display: 'flex',
        flexWrap: 'wrap',
        borderRight: `solid 1px ${palette.divider}`,
        marginBottom: 4,
        transform: 'translateZ(0)',
        position: 'relative',
    },
});
exports.daysGridStyles = daysGridStyles;
const transactionLabelStyles = ({ palette, components: { calendar } }, _props, classes) => ({
    // type styles
    moreType: {
        background: 'none',
        '&:hover': {
            background: 'none',
        },
    },
    incomeType: {
        background: calendar.incomeColor,
        '&:hover': {
            background: calendar.incomeColor,
        },
    },
    expenseType: {
        background: calendar.expenseColor,
        '&:hover': {
            background: calendar.expenseColor,
        },
    },
    overdueType: {
        background: `${calendar.overdueColor} !important`,
        '&:hover': {
            background: calendar.overdueColor,
        },
    },
    normalType: {
        background: calendar.normalColor,
        '&:hover': {
            background: calendar.normalColor,
        },
    },
    dueType: {
        [`& .${classes.reminderIcon}`]: {
            display: 'inline-block',
            color: palette.greyScaleDeprecated[3],
            opacity: 0.90,
        },
    },
    label: {
        height: 6,
        width: 6,
        borderRadius: '50%',
        display: 'inline-block',
        margin: '0px 1px 0px 1px',
    },
});
exports.transactionLabelStyles = transactionLabelStyles;
const calendarPrefsStyles = ({ typography }) => ({
    dialogPaper: {
        overflowY: 'visible',
    },
    buttonArea: {
        padding: 10,
        paddingTop: 0,
        display: 'flex',
        justifyContent: 'space-between',
    },
    fieldRoot: {
        display: 'flex',
        minWidth: 450,
    },
    fieldLabel: Object.assign(Object.assign({}, typography.body2), { flexGrow: 2, marginTop: 'auto', marginBottom: 'auto' }),
});
exports.calendarPrefsStyles = calendarPrefsStyles;
